let holdManualAvailability = false;
let holdReconnectAvailability = false;
let reconnectHoldTimer = null;

// Reconnect paint hold only. Agent offline follows 30/90 min activity bands, not this timer.
export const RECONNECT_OFFLINE_HOLD_MS = 60000;

export function pinManualAvailability() {
  holdManualAvailability = true;
}

export function releaseManualAvailabilityHold() {
  holdManualAvailability = false;
}

export function pinReconnectAvailability(
  durationMs = RECONNECT_OFFLINE_HOLD_MS
) {
  holdReconnectAvailability = true;
  if (reconnectHoldTimer) {
    clearTimeout(reconnectHoldTimer);
  }
  reconnectHoldTimer = setTimeout(() => {
    holdReconnectAvailability = false;
    reconnectHoldTimer = null;
  }, durationMs);
}

export function releaseReconnectAvailabilityHold() {
  holdReconnectAvailability = false;
  if (reconnectHoldTimer) {
    clearTimeout(reconnectHoldTimer);
    reconnectHoldTimer = null;
  }
}

function overlayLooksOffline(overlayStatus) {
  return !overlayStatus || overlayStatus === 'offline';
}

function overlayLooksAwayOrOffline(overlayStatus) {
  return overlayLooksOffline(overlayStatus) || overlayStatus === 'auto_offline';
}

export function shouldApplyOverlayStatus(overlayStatus) {
  if (holdManualAvailability && overlayLooksAwayOrOffline(overlayStatus)) {
    return false;
  }

  if (holdReconnectAvailability && overlayLooksOffline(overlayStatus)) {
    return false;
  }

  if (!overlayLooksAwayOrOffline(overlayStatus)) {
    holdManualAvailability = false;
    releaseReconnectAvailabilityHold();
  }

  return true;
}
